<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 9.75V3.375C12 2.87772 11.8025 2.40081 11.4508 2.04917C11.0992 1.69754 10.6223 1.5 10.125 1.5C9.62772 1.5 9.15081 1.69754 8.79917 2.04917C8.44754 2.40081 8.25 2.87772 8.25 3.375V14.7437L6.19429 11.1831C6.07129 10.9697 5.90743 10.7825 5.71207 10.6324C5.51672 10.4823 5.2937 10.3722 5.05576 10.3083C4.81782 10.2445 4.56962 10.2281 4.32536 10.2602C4.08111 10.2923 3.84557 10.3723 3.63221 10.4955C3.41886 10.6186 3.23187 10.7827 3.08194 10.9781C2.932 11.1736 2.82206 11.3967 2.7584 11.6347C2.69474 11.8727 2.6786 12.1209 2.71091 12.3652C2.74322 12.6094 2.82334 12.8449 2.9467 13.0581C6 19.5 7.85786 21.75 12 21.75C12.9849 21.75 13.9602 21.556 14.8701 21.1791C15.7801 20.8022 16.6069 20.2497 17.3033 19.5533C17.9997 18.8569 18.5522 18.0301 18.9291 17.1201C19.306 16.2102 19.5 15.2349 19.5 14.25V10.5C19.5 10.0027 19.3025 9.52581 18.9508 9.17417C18.5992 8.82254 18.1223 8.625 17.625 8.625C17.1277 8.625 16.6508 8.82254 16.2992 9.17417C15.9475 9.52581 15.75 10.0027 15.75 10.5"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.75 10.5V9.375C15.75 8.87772 15.5525 8.40081 15.2008 8.04917C14.8492 7.69754 14.3723 7.5 13.875 7.5C13.3777 7.5 12.9008 7.69754 12.5492 8.04917C12.1975 8.40081 12 8.87772 12 9.375V9.75"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
